<template>
  <div>
    <v-card class="mx-auto ml-5 my-5 mx-5 mr-5" outlined>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr class="orange darken-1">
              <th colspan="10" class="text-center">
                <span class="white--text text-h6"
                  >MONTHLY SALES PLAN REPORT</span
                >
              </th>
            </tr>
            <tr>
              <th class="text-left">ENGINEER</th>
              <th class="text-left">ENQUIRY</th>
              <th class="text-left">FOLLOW UP</th>
              <th class="text-left">NEGOTIATION</th>
              <th class="text-left">CONFIRM</th>
              <th class="text-left">FOL UP CLOSED</th>
              <th class="text-left">LOST</th>
              <th class="text-left">BILLED</th>
              <th class="text-left">RESCHDULED</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(record, m) in chartData.salesengineerMonthlysalesplan"
              :key="m"
            >
              <td>{{ record.name }}</td>
              <td>{{ record.enquiryValue }}</td>
              <td>{{ record.enquiryFollowupvalue }}</td>
              <td>{{ record.enquiryNegotiationvalue }}</td>
              <td>{{ record.enquiryConfirmvalue }}</td>
              <td>{{ record.enquiryFoloupclosedvalue }}</td>
              <td>{{ record.enquiryLostvalue }}</td>
              <td>{{ record.enquiryBilledvalue }}</td>
              <td>{{ record.enquiryReschduledvalue }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>

    <v-card class="mx-auto ml-5 my-5 mx-5 mr-5 " outlined>
      <highcharts :options="chartOptions" ref="highcharts"></highcharts>
      <!--<button @click="updateCredits">update credits</button>-->
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src

import { mapGetters, mapActions } from "vuex";

import { VUE_APP_BASEURL } from "../utils/api";
import axios from "axios";
import store from "../store";

export default {
  name: "MonthlySalesPlanBarChart",
  props: [
    "selectedsegment",
    "selectedsalesengineer",
    "selectedregion",
    "selectedproductgroup",
    "selecteddaterange"
  ],
  data: () => ({
    chartOptions: {
      chart: {
        type: "column"
      },
      title: {
        text: "MONTHLY SALES PLAN REPORT"
      },
      subtitle: {
        text: ""
      },
      xAxis: {
        categories: [],
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: ""
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [{}],
      credits: {
        enabled: false
      }
    }
  }),
  components: {},
  computed: {
    ...mapGetters(["getmonthlysalesplanChart"]),
    chartData: function() {
      return this.getmonthlysalesplanChart;
    }
  },
  mounted() {
    /*  setTimeout(() => {
        this.chartOptions.series=this.chartData.monthlySalesplanbarchartData;
        this.chartOptions.xAxis.categories=this.chartData.monthlysalesplanDates;
        //console.log('updated');
        }, 3500)*/
  },
  created() {
    const filterData = [];
    this.monthlySalesplanchart(filterData);
    this.monthlysalesplanbarchartload(this.chartOptions);
  },
  methods: {
    ...mapActions(["monthlySalesplanchart"]),

    monthlysalesplanbarchartload(chartOptions) {
      const filterData = [];

      axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getters.UserToken
        },
        url: VUE_APP_BASEURL + "chart/monthlysalesplan-chart-data",
        data: {
          product: filterData.product,
          segment: filterData.segment,
          salesengineer: filterData.salesengineer,
          status: filterData.status,
          region: filterData.region,
          productgroup: filterData.productgroup,
          daterange: filterData.daterange
        }
      })
        .then(function(response) {
          //chartOptions.series[0].data=response.data.response.monthlySalesplanpiechartData;

          chartOptions.series =
            response.data.response.monthlySalesplanbarchartData;
          chartOptions.xAxis.categories =
            response.data.response.monthlysalesplanDates;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    filterMonthlySalesPlanChart() {
      const filterData = {
        segment: this.selectedsegment,
        salesengineer: this.selectedsalesengineer,
        daterange: this.selecteddaterange,
        region: this.selectedregion,
        productgroup: this.selectedproductgroup,
        product: "",
        status: ""
      };

      const chartOptions = this.chartOptions;
      axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getters.UserToken
        },
        url: VUE_APP_BASEURL + "chart/monthlysalesplan-chart-data",
        data: {
          product: filterData.product,
          segment: filterData.segment,
          salesengineer: filterData.salesengineer,
          status: filterData.status,
          daterange: filterData.daterange,
          region: filterData.region,
          productgroup: filterData.productgroup
        }
      })
        .then(function(response) {
          console.log(response);
          chartOptions.series =
            response.data.response.monthlySalesplanbarchartData;
          chartOptions.xAxis.categories =
            response.data.response.monthlysalesplanDates;
        })
        .catch(function(error) {
          console.log(error);
          console.log(error.response);
        });

      this.monthlySalesplanchart(filterData);
      /* setTimeout(() => {
        this.chartOptions.series=this.chartData.monthlySalesplanbarchartData;
        this.chartOptions.xAxis.categories=this.chartData.monthlysalesplanDates;
        }, 3500)*/
    }
  }
};
</script>
